<div class="row" [formGroup]="parentForm">
  <ng-container formArrayName="additionalFields">
    <ng-container *ngFor='let group of additionalFields.controls; let i=index'>
      <ng-container [formGroup] = group>
        <div class="input-container input-container--lg" *ngIf="this.additionalFieldDefinitions !== undefined">
          <label class="input-container__label">
            {{this.additionalFieldDefinitions[i].fieldName}} <span *ngIf="fieldRequired(this.additionalFieldDefinitions[i])" >*</span>
            <input
              id="add-order-msg-field.input-{{this.getFieldNameWithoutWhiteSpace(i)}}"
              *ngIf="this.additionalFieldDefinitions[i].fieldType === localTypeEnum.textBox"
              type="text"
              class="input-container__field"
              formControlName="fieldValue">
          </label>
          <dx-select-box
            id="add-order-msg-field.select-{{this.getFieldNameWithoutWhiteSpace(i)}}"
            *ngIf="this.additionalFieldDefinitions[i].fieldType === localTypeEnum.dropList"
            class="input-container__field"
            [dataSource]="this.additionalFieldDefinitions[i].dropListOptions"
            formControlName="fieldValue"
            [showClearButton]="!fieldRequired(this.additionalFieldDefinitions[i])">
          </dx-select-box>
          <app-control-messages class="input-container__error" [control]="group.get('fieldValue')">
          </app-control-messages>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

